import { parseISO, format } from "date-fns"

const adjustDateForTimezone = (isoDateStr: string) => {
  if (!isoDateStr) return undefined

  const date = parseISO(isoDateStr)

  const dateString = format(date, "yyyy-MM-dd")

  return new Date(dateString + "T00:00:00")
}

export default adjustDateForTimezone
